import { render, staticRenderFns } from "./DangerZoneIcon.vue?vue&type=template&id=14541bde"
import script from "./DangerZoneIcon.vue?vue&type=script&lang=js"
export * from "./DangerZoneIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports